import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { DiscountsRouteNames, DiscountsRoutePathNames } from '../../../../enums';
import { beforeEnter } from '../../../../routes/guards/index';

const Component = () => import('./RystPromoManagement.vue');

export default {
  path: buildChildURL(
    DiscountsRoutePathNames.RYST_INCENTIVES_MANAGER,
    DiscountsRoutePathNames.RYST_PROMO_MANAGEMENT,
  ),
  name: DiscountsRouteNames.RYST_PROMO_MANAGEMENT,
  component: Component,
  beforeEnter,
} as RouteRecordRaw;
